module.exports = __webpack_public_path__ + "img/logoo.54f121be.png";